jQuery(function () {
    $('.select-house-ts').change(function (e) {
        var checkedId = $(e.target).val();
        $.ajax({
            type: 'POST',
            url: '/api/selectedhouse/set',
            data: { 'houseid': checkedId },
            success: function () {
                window.location.href = '/';
            }
        });
    });
});
